/* BASIQ · Filas deslizables (reseñas + UGC): barra de progreso, arrastre con ratón y vídeos siempre sin audio */
(function () {
  if (window.__bpScrollerReady) return;
  window.__bpScrollerReady = true;

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        v.muted = true;
        if (en.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
  }

  function setupVideos(root) {
    root.querySelectorAll('video').forEach(function (v) {
      if (v.dataset.bpReady === '1') return;
      v.dataset.bpReady = '1';
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.removeAttribute('controls');
      v.addEventListener('volumechange', function () {
        if (!v.muted) v.muted = true;
      });
      if (io) {
        v.setAttribute('preload', 'metadata');
        io.observe(v);
      } else {
        v.play && v.play().catch(function () {});
      }
    });
  }

  function setup(el) {
    if (!el || el.dataset.ready === '1') return;
    el.dataset.ready = '1';

    var track = el.querySelector('[data-scroller-track]');
    var thumb = el.querySelector('[data-scroller-thumb]');
    if (!track) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      el.classList.toggle('is-static', max <= 1);
      if (!thumb) return;
      var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var w = Math.max(ratio * 100, 12);
      var left = max > 0 ? (track.scrollLeft / max) * (100 - w) : 0;
      thumb.style.width = w + '%';
      thumb.style.left = left + '%';
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();

    /* Arrastre con ratón (en táctil se desliza de forma nativa) */
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) {
        track.scrollLeft = startLeft - dx;
        e.preventDefault();
      }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('is-dragging');
        setTimeout(function () { moved = false; }, 0);
      }
    });
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    setupVideos(el);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bp-scroller]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
